import { render, staticRenderFns } from "./Wallets.vue?vue&type=template&id=4979f373&scoped=true&"
import script from "./Wallets.vue?vue&type=script&lang=js&"
export * from "./Wallets.vue?vue&type=script&lang=js&"
import style0 from "./Wallets.vue?vue&type=style&index=0&id=4979f373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4979f373",
  null
  
)

export default component.exports